module.exports = __webpack_public_path__ + "img/时尚阅读.07680b81.jpg";